import React from 'react';
import { Card, Segmented, Button } from 'antd';
import { 
  MessageOutlined, 
  AudioOutlined
} from '@ant-design/icons';
import { useApp } from '../../contexts/AppContext';
import ChatArea from './ChatArea';
import ChatInput from './ChatInput';
import { VoiceInput } from '../Voice';
import { Logo, RefreshIcon } from '../Common';
import './ChatInterface.css';

const ChatInterface: React.FC = () => {
  const { state, dispatch } = useApp();

  const handleModeChange = (value: string) => {
    const newMode = value as 'chatbot' | 'voicebot';
    dispatch({ type: 'SET_CHAT_MODE', payload: newMode });
  };


  const handleRefresh = () => {
    if (state.chatMode === 'chatbot') {
      dispatch({ type: 'CLEAR_CHATBOT_MESSAGES' });
    } else {
      dispatch({ type: 'CLEAR_VOICEBOT_MESSAGES' });
    }
  };


  return (
    <div className="chat-container">
      <Card className="chat-card">
        {/* Header */}
        <div className="chat-header">
          <div className="chat-title-section">
            <div className="assistant-info">
              <div className="assistant-icon">
                <Logo size={24} />
              </div>
            <div className="assistant-details">
              <span className="assistant-name">Immigration Voice Assistant</span>
              <p className="assistant-description">
                Ask about visas, flights, immigration rules, and more
              </p>
            </div>
            </div>
          </div>
          
          <div className="chat-controls">
            <div className="window-controls">
              <Button 
                type="text" 
                icon={<RefreshIcon size={16} color="#8c8c8c" />} 
                className="control-button"
                onClick={handleRefresh}
              />
            </div>
          </div>
        </div>

        {/* Mode Toggle */}
        <div className="mode-toggle">
          <Segmented
            options={[
              {
                label: (
                  <div className="mode-option">
                    <MessageOutlined />
                    <span>Chatbot</span>
                  </div>
                ),
                value: 'chatbot',
              },
              {
                label: (
                  <div className="mode-option">
                    <AudioOutlined />
                    <span>Voicebot</span>
                  </div>
                ),
                value: 'voicebot',
              },
            ]}
            value={state.chatMode}
            onChange={handleModeChange}
            className="mode-segmented"
          />
        </div>

        {/* Chat Area */}
        <div className="chat-area-wrapper">
          <ChatArea />
        </div>

        {/* Input Area */}
        <div className="input-area">
          {state.chatMode === 'chatbot' ? (
            <ChatInput />
          ) : (
            <VoiceInput />
          )}
        </div>
      </Card>
    </div>
  );
};

export default ChatInterface;
